import axios, { endpoints } from 'src/utils/axios';

import { STORAGE_KEY } from './constant';
import { POLICY } from 'src/utils/constants';

// ----------------------------------------------------------------------

export function jwtDecode(token) {
  try {
    if (!token) return null;

    const parts = token.split('.');
    if (parts.length < 2) {
      throw new Error('Invalid token!');
    }

    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64));
  } catch (error) {
    console.error('Error decoding token:', error);
    throw error;
  }
}

// ----------------------------------------------------------------------

export function isValidToken(accessToken) {
  if (!accessToken) {
    return false;
  }

  try {
    const decoded = jwtDecode(accessToken);

    if (!decoded || !('exp' in decoded)) {
      return false;
    }

    const currentTime = Date.now() / 1000;

    return decoded.exp > currentTime;
  } catch (error) {
    console.error('Error during token validation:', error);
    return false;
  }
}

// ----------------------------------------------------------------------

export function tokenExpired(exp) {
  const currentTime = Date.now();
  const timeLeft = exp * 1000 - currentTime;

  setTimeout(() => {
    try {
      axios
        .post(`${endpoints.auth.refreshToken}`, null, {
          headers: {
            Accept: 'text/plain',
          },
        })
        .then((res) => {
          const accessToken = res.data;

          if (!accessToken) {
            throw new Error('Access token not found in response');
          }

          setSession(accessToken);
        })
        .catch((e) => {
          console.log(e);
          /* alert('Token expired!');
        localStorage.removeItem(STORAGE_KEY);
        window.location.href = paths.auth.jwt.signIn; */
        });
    } catch (error) {
      console.error('Error during token expiration:', error);
      throw error;
    }
  }, timeLeft);
}

// ----------------------------------------------------------------------

export async function setSession(accessToken) {
  try {
    if (accessToken) {
      localStorage.setItem(STORAGE_KEY, accessToken);

      axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

      // const decodedToken = jwtDecode(accessToken);
      // if (decodedToken && 'exp' in decodedToken) {
      //   tokenExpired(decodedToken.exp);
      // } else {
      //   throw new Error('Invalid access token!');
      // }
    } else {
      localStorage.removeItem(STORAGE_KEY);
      delete axios.defaults.headers.common.Authorization;
    }
  } catch (error) {
    console.error('Error during set session:', error);
    throw error;
  }
}

export const getDecodedToken = () => {
  const accessToken = localStorage.getItem(STORAGE_KEY);
  return jwtDecode(accessToken);
};

export const hasUserAccess = (policies) => {
  const accessToken = localStorage.getItem(STORAGE_KEY);
  const decodedToken = jwtDecode(accessToken);

  if (!policies || !policies?.length) {
    return true;
  }

  return decodedToken?.policies?.includes(POLICY.ALL)
    ? true
    : policies?.some((role) =>
        decodedToken?.policies
          ?.trim()
          ?.split(',')
          ?.some((r) => r === role)
      );
};
